
import Caret from '@/components/icons/Caret.vue'
import { defineComponent, ref } from 'vue'
import { theme } from '@/config/styles'

const __default__ = defineComponent({
    props: {
        title: {
            type: String,
            default: 'Title',
        },
        content: {
            type: String,
            default: 'content',
        },
    },
    components: {
        Caret,
    },
    setup() {
        const isCollapsed = ref(true)

        const onHeaderClicked = (): void => {
            isCollapsed.value = isCollapsed.value ? false : true
        }
        return {
            onHeaderClicked,
            isCollapsed,
            theme
        }
    },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "24c9ac40": (_ctx.theme.colors.black),
  "06472359": (_ctx.theme.colors.primary.midlight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__